import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/app';

import './scss/_base.scss';
import './scss/_browsers.scss';

ReactDOM.render(<App />, document.getElementById('root'));